import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import { BREAKPOINT } from '@constants';
import { ArticleAuthor, ArticleIllustrator, ArticleMedReviewer } from '@contracts';
import { hasAnyRelationsPrismic } from '@utils/helpers';
import ArticleContributorType from './ArticleContributorType';

export interface Props {
  authors: ArticleAuthor[];
  illustrators: ArticleIllustrator[];
  med_reviewers: ArticleMedReviewer[];
}

export default function ArticleContributors({ authors, illustrators, med_reviewers }: Props) {
  const { t } = useTranslation();

  const authorsRelationData = authors.map((item) => ({ ...item.article_author }));
  const medReviewersRelationData = med_reviewers.map((item) => ({ ...item.medical_reviewer }));
  const illustratorsRelationData = illustrators.map((item) => ({ ...item.illustrator }));

  return (
    <Container>
      {hasAnyRelationsPrismic(authorsRelationData) && (
        <ArticleContributorType contributors={authorsRelationData} introText={t('components.vitals-author')} />
      )}
      {hasAnyRelationsPrismic(medReviewersRelationData) && (
        <ArticleContributorType contributors={medReviewersRelationData} introText={t('components.vitals-med-reviewed-by')} />
      )}
      {hasAnyRelationsPrismic(illustratorsRelationData) && (
        <ArticleContributorType contributors={illustratorsRelationData} introText={t('components.vitals-illustrated-by')} />
      )}
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  height: auto;
  position: relative;
  text-align: left;
  transform: none;
  position: relative;

  @media only screen and (max-width: ${BREAKPOINT.laptop}px) {
    max-width: 100%;
    width: 100%;
    margin-left: 0;
    position: relative;
  }
`;
